import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import {
  Clipboard,
  Clone,
  Copy,
  EllipsisVertical,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

// Key the menu reports to Toolbar.Root; the picked item follows it.
export const MORE_MENU_ID = 'more'

interface ContentProps {
  duplicateDisabled: boolean
  pasteDisabled: boolean
}

const Content: React.FC<ContentProps> = ({
  duplicateDisabled,
  pasteDisabled,
}) => (
  <TinyDropdownMenu.Group>
    <TinyDropdownMenu.Button icon={Copy} id="copy" label="Copy" />
    <TinyDropdownMenu.Button
      disabled={duplicateDisabled}
      icon={Clone}
      id="duplicate"
      label="Duplicate"
    />
    <TinyDropdownMenu.Button
      disabled={pasteDisabled}
      icon={Clipboard}
      id="paste"
      label="Paste"
    />
  </TinyDropdownMenu.Group>
)

// The menu closes on Paste, so the button carries the loader while the
// clipboard is read and applied.
const Trigger = forwardRef<HTMLButtonElement, { loading: boolean }>(
  ({ loading }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    return (
      <Toolbar.DropdownButton
        active={active}
        icon={EllipsisVertical}
        loading={loading}
        onClick={toggle}
        ref={ref}
        tooltip="More"
      />
    )
  }
)

interface Props {
  duplicateDisabled: boolean
  pasteDisabled: boolean
  pasting: boolean
}

export const MoreMenu: React.FC<Props> = ({
  duplicateDisabled,
  pasteDisabled,
  pasting,
}) => {
  const { onClick } = Toolbar.useToolbarClick(MORE_MENU_ID)

  return (
    <TinyDropdownMenu.Root
      content={Content}
      duplicateDisabled={duplicateDisabled}
      onClick={onClick}
      pasteDisabled={pasteDisabled}
    >
      <Trigger loading={pasting} />
    </TinyDropdownMenu.Root>
  )
}
